import React, { useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { DataContext } from '../Context/Context';
import emptyCart from '../../assets/svg/empty-cart.svg'
import CartModalList from './CartModalList';


function CartModal() {
  const value = useContext(DataContext);
  const [cart, setCart] = value.cart;
  const increase = value.increase;
  const decrease = value.decrease;
  const removeProduct = value.removeProduct;
  const [total, setTotal] = useState(0);
  const [showCartModal, setShowCartModal] = useState(false);

  useEffect(() => {
    const getTotal = () => {
      const res = cart.reduce((prev, item) => {
        return prev + (item.price * item.count)
      }, 0)
      setTotal(res)
    }
    getTotal()
  }, [cart]);

  const handleMouseEnterCart = () => {
    setShowCartModal(true);
  };
  const handleMouseLeaveCart = () => {
    setShowCartModal(false);
  };
  return (
    <>
      <div
          onMouseEnter={handleMouseEnterCart}
          onMouseLeave={handleMouseLeaveCart}
          className='align-items-center ms-3 py-2 cartH d-inline'>
          <span className='position-absolute bg-danger badge rounded-pill  cart-number '>{cart.length}</span>
          <Link to='/cart' > <i className="bi bi-cart3 h4 "></i>  </Link>
          {
            showCartModal && (
              <>
                {cart.length === 0 && (
                  <div className="mini-cart shadow-bottom d-none d-lg-block overflow-hidden">
                    <figure className='py-5'>
                      <img src={emptyCart} alt="" />
                      <figcaption className='py-5 h5'> سبد خرید شما خالی است . </figcaption>
                    </figure>
                  </div>
                )}
                <CartModalList cart={cart} increase={increase} decrease={decrease} removeProduct={removeProduct} />
              </>
            )
          }

        </div>
    </>
  )
}

export default CartModal